import { z } from "zod";

// API07: thời gian ISO-8601 UTC · ID là UUID opaque · tiền = số nguyên đơn vị nhỏ nhất + currency.
export const Uuid = z.string().uuid();
export const IsoDateTime = z.string().datetime({ offset: false });
export const Money = z.object({ amount: z.number().int(), currency: z.string().length(3) }).strict();

// API03: phân trang cursor + limit, cấm OFFSET sâu.
export const CursorQuery = z.object({ cursor: z.string().max(512).optional(), limit: z.coerce.number().int().min(1).max(100).default(25) });
export type CursorQuery = z.infer<typeof CursorQuery>;

export interface KeysetCursor {
  readonly t: string;
  readonly id: string;
}

// base64url không dùng Buffer: gói này chạy cả ở FE.
function toB64Url(text: string): string {
  const bytes = new TextEncoder().encode(text);
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
}

function fromB64Url(raw: string): string {
  const b64 = raw.replaceAll("-", "+").replaceAll("_", "/");
  const bin = atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4));
  return new TextDecoder().decode(Uint8Array.from(bin, (ch) => ch.charCodeAt(0)));
}

export function encodeCursor(c: KeysetCursor): string {
  return toB64Url(JSON.stringify([c.t, c.id]));
}

export function decodeCursor(raw: string | undefined): KeysetCursor | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(fromB64Url(raw)) as unknown;
    if (Array.isArray(v) && v.length === 2 && typeof v[0] === "string" && typeof v[1] === "string" && Uuid.safeParse(v[1]).success && !Number.isNaN(Date.parse(v[0]))) {
      return { t: v[0], id: v[1] };
    }
  } catch {
    return null;
  }
  return null;
}

/** API04: khai hành vi Idempotency-Key trong contract (P0 chưa bắt buộc). */
export type IdempotencyBehavior = "none" | "optional" | "required";
